import { StyledMenu } from "./action-menu.style";
import { MDSActionMenuProps } from "./action-menu.types";
import React from "react";

/**
 * MDSActionMenu is a menu that displays a list of actions.
 * It implements react-aria's Menu component.
 * It differs from MDSSelectMenu in that the items are not designed to be selectable; clicking an item immediately dismisses the menu
 */
export const MDSActionMenu = React.forwardRef<HTMLDivElement, MDSActionMenuProps>((props, ref) => {
  return <StyledMenu data-mds-name="action-menu" aria-label="Menu" {...props} ref={ref} />;
});
